function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
var first_scroll = true;
var first_anmation = true;

function secondaryImageMobile(imageSections){
  imageSections.forEach(section => {
    if(section.querySelector('.product-card--show-secondary-media')){
      let number_seconds = parseInt(section.querySelector('.product-card--show-secondary-media').dataset.speed);
      // console.log("number_seconds:",number_seconds);
      if(number_seconds > 0){
        if(isInViewport(section) && first_anmation){
          let blocks = section.querySelectorAll('.image-link-blocks__item');
          blocks.forEach(block => {
            block.querySelector('.product-card__figure').classList.add("hovering_effect");
          });
          setTimeout(() => {
            let blocks = section.querySelectorAll('.image-link-blocks__item');
            blocks.forEach(block => {
              block.querySelector('.product-card__figure').classList.remove("hovering_effect");
            });
          }, (number_seconds*1000));
          first_anmation = false;
        }
      }
    }
  });
}

function imageLinkBlocksSectionBehaviour(){
  let image_link_blocks = document.querySelectorAll(".shopify-section--image-link-blocks");
  if( image_link_blocks.length > 0 && window.innerWidth <= 699){
    document.addEventListener("scroll", () => {
      secondaryImageMobile(image_link_blocks);
    });
  }
}

function imageBannerAnimation(animationSections){
  animationSections.forEach(section => {
    if(section.querySelector('.banner_second_animation')){
      let number_seconds = parseInt(section.querySelector('.section').dataset.speed);
      if(number_seconds > 0){
        if(section.classList.contains("banner_viewport_effect") && !isInViewport(section)){
          section.classList.remove("banner_viewport_effect");
        }
        if(isInViewport(section)){
          setTimeout(() => {
            // console.log("isInViewport(section):",isInViewport(section));
              section.classList.add("banner_viewport_effect");
          }, (number_seconds*1000));
        }
      }
    }
  });
}

function imagesAnimationSectionBehaviour(){
  let images_animation_sections = document.querySelectorAll(".image-animation-section");
  if( images_animation_sections.length > 0 ){
    imageBannerAnimation(images_animation_sections);
    document.addEventListener("scroll", () => {
      imageBannerAnimation(images_animation_sections);
    });
  }
}

document.addEventListener('DOMContentLoaded', function(){
  imageLinkBlocksSectionBehaviour();
  document.addEventListener("resize", () => {
    imageLinkBlocksSectionBehaviour();
  });
  imagesAnimationSectionBehaviour();
});

// Added the code so we can also change the language when the market switches
// https://shopify.dev/docs/storefronts/themes/markets/multiple-currencies-languages
 class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    this.querySelector('.change_language').setAttribute('value',event.currentTarget.dataset.lang);
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

// Play/Stop Function For Marquee-Text
function adjustMarqueeStartPause(marqueeContainers){
  marqueeContainers.forEach(container => {
    // Select the start and pause buttons
    let startButton = container.querySelector(".start_scrolling"),
        pauseButton = container.querySelector(".pause_scrolling"),
        // Select the marquee text elements
        marqueeTexts = container.querySelectorAll("marquee-text span");
    // Add event listeners to the start and pause buttons to toggle the marquee text and button states
    startButton.addEventListener("click", event => {
      toggleMarquee(marqueeTexts, startButton, pauseButton);
    });
    pauseButton.addEventListener("click", event => {
      toggleMarquee(marqueeTexts, startButton, pauseButton);
    });
  });
}
function toggleMarquee(marqueeTexts, startButton, pauseButton) {
  // Toggle the pause class on the marquee text elements
  marqueeTexts.forEach(text => {
    text.classList.toggle("pause_scrolling");
  });
  // Toggle the hidden class on the start and pause buttons
  startButton.classList.toggle("hidden");
  pauseButton.classList.toggle("hidden");
}

// Play/Pause of video controls
class CustomVideoControls {
  constructor() {
    this.init();
  }

  init() {
    const videoButtons = document.querySelectorAll('.scrolling_video_btns');
    if (!videoButtons.length) return;

    videoButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleClick(e, button));
    });
  }

  handleClick(event, button) {
    const playBtn = button.querySelector('.start_playing');
    const pauseBtn = button.querySelector('.pause_playing');
    const videoContainer = button.closest('video-media');
    const slideshowContainer = button.closest('slideshow-carousel');

    // Handle single video
    if (videoContainer) {
      this.toggleVideo(videoContainer, event);
    }

    // Handle slideshow videos
    if (slideshowContainer) {
      const selectedSlide = slideshowContainer.querySelector('.slideshow__slide.is-selected');
      if (selectedSlide) {
        selectedSlide.querySelectorAll('video-media').forEach(container => {
          this.toggleVideo(container, event);
        });
      }
    }

    // Toggle button visibility
    if (playBtn && pauseBtn) {
      playBtn.classList.toggle('hidden');
      pauseBtn.classList.toggle('hidden');
    }
  }

  toggleVideo(container, event) {
    const video = container.querySelector('video');
    if (!video) return;

    const isPause = event.target.closest('.pause_playing');
    const isPlay = event.target.closest('.start_playing');

    try {
      if (isPause) {
        video.pause();
      } else if (isPlay) {
        video.play().catch(err => console.error('Play failed:', err));
      }
    } catch (error) {
      console.error('Video control error:', error);
    }
  }
}

window.addEventListener("load", function(){
  let marqueeContainers = document.querySelectorAll(".scrolling_marquee");
  if(marqueeContainers.length > 0){
    // Adjust the start and pause buttons for the marquee containers
    adjustMarqueeStartPause(marqueeContainers);
  }
  new CustomVideoControls();
});

// ---------------------------------------------------------------------------
// Cart drawer: always re-sync its live content on every page show.
// Fixes the cart drawer showing stale content after browser back/forward
// navigation (the browser serves an old cached document, so the server-rendered
// drawer is out of date even though /cart.js is correct). Instead of touching the
// DOM directly, we build the same payload the theme uses on add-to-cart / quantity
// change and dispatch the theme's own `cart:change` event - so the drawer, cart
// count, gamification bar and Loop bundle all re-render through the theme's
// existing handlers, consistently.
// ---------------------------------------------------------------------------
(function () {
  let cartReloading = false;

  async function reloadCartDrawer(reason) {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer || cartReloading) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

    // console.log("[cart-reload] start", { reason }, performance.now().toFixed(0) + "ms");
    cartReloading = true;
    try {
      // Ask the drawer (and any other listeners) which sections to render, exactly
      // like the theme's own quantity-change flow. The drawer pushes its section id,
      // which is the key the theme's cart:change handler reads back.
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sections }
      }));

      // no-store: on back/forward the browser can serve a STALE cached /cart.js,
      // which would give a wrong count even though the section HTML is fresh.
      const cart = await (await fetch(root + "cart.js", { cache: "no-store" })).json();
      cart.sections = await (await fetch(root + "?sections=" + sections.join(","), { cache: "no-store" })).json();
      // console.log("[cart-reload] fetched", { sections: sections, item_count: cart.item_count }, performance.now().toFixed(0) + "ms");

      // Loop subscription bundles: the drawer's line-item loop skips bundle child
      // items; they are rendered by initLoopBundle from window.Loop.bundleCartAllItems.
      // Feed it the fresh cart items so the bundle rows re-render (the theme's own
      // cart:change handler calls initLoopBundle but does not refresh this list).
      window.Loop = window.Loop || {};
      window.Loop.bundleCartAllItems = cart.items || [];

      // baseEvent "variant:add" makes the theme update the drawer content immediately
      // (no 1250ms debounce). This does NOT open the drawer (that is the separate
      // "variant:add" event, which we are not dispatching).
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "variant:add", cart: cart }
      }));
      // console.log("[cart-reload] cart:change dispatched", performance.now().toFixed(0) + "ms");

      // Explicitly sync every cart-count bubble (header + drawer). The header one
      // carries an `opacity-0` class when the cart was empty at render time, so we
      // also toggle visibility to keep it consistent with the live count.
      document.querySelectorAll("cart-count").forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle("opacity-0", cart.item_count === 0);
      });
      // console.log("[cart-reload] cart-count bubbles synced ->", cart.item_count, performance.now().toFixed(0) + "ms");

      // NOTE: we do NOT call initLoopBundle here - the theme's own cart:change
      // handler already calls it once (and it appends bundle rows, so a second call
      // duplicates them). We only refresh window.Loop.bundleCartAllItems above so
      // the theme's call renders the bundle from fresh data. Duplicate bundle rows
      // (from stacked initLoopBundle prepends) are collapsed in real time by the
      // MutationObserver set up below - before the browser paints, so no flash.
    } catch (e) {
      // console.log("[cart-reload] failed", e);
    } finally {
      cartReloading = false;
      // console.log("[cart-reload] done", performance.now().toFixed(0) + "ms");
    }
  }

  // Remove duplicate Loop bundle rows from the drawer, keyed by bundleId (read from
  // the row's removeBundleLoop('<id>') link). Regular line items have no such link
  // and are left untouched. Idempotent: keeps the first row per bundle, drops the rest.
  function dedupeBundleRows() {
    const container = document.querySelector(".loop_bundleDrawer_cart_items");
    if (!container) return;
    const seen = {};
    let removed = 0;
    container.querySelectorAll(":scope > line-item").forEach(function (row) {
      const removeLink = row.querySelector('[onclick*="removeBundleLoop"]');
      if (!removeLink) return; // regular (non-bundle) line item
      const match = (removeLink.getAttribute("onclick") || "").match(/removeBundleLoop\(['"]([^'"]+)['"]\)/);
      const id = match ? match[1] : removeLink.getAttribute("onclick");
      if (seen[id]) {
        row.remove();
        removed++;
      } else {
        seen[id] = true;
      }
    });
    if (removed) {
      // console.log("[cart-reload] removed duplicate bundle rows:", removed);
    }
  }

  // Collapse duplicate bundle rows the instant Loop prepends them. The observer
  // callback runs as a microtask (before the browser paints), so a stacked
  // initLoopBundle never flashes a doubled bundle. We observe the stable cart-drawer
  // host with subtree:true because its inner content (and the bundle container) is
  // replaced on every update. dedupeBundleRows is idempotent and self-terminating:
  // its own removals re-trigger the observer once more, which then finds nothing.
  (function watchBundleDuplicates() {
    const drawerEl = document.getElementById("cart-drawer");
    if (!drawerEl) return;
    new MutationObserver(function () {
      dedupeBundleRows();
    }).observe(drawerEl, { childList: true, subtree: true });
  })();

  // Fresh document loads: initial load, reload, and HTTP-cache back/forward
  // navigation (where event.persisted is false). Run as early as possible.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      reloadCartDrawer("DOMContentLoaded");
    });
  } else {
    reloadCartDrawer("script-run");
  }

  // True back/forward cache restores (DOM preserved, scripts not re-run).
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      reloadCartDrawer("pageshow-persisted");
    }
  });

  // ---------------------------------------------------------------------------
  // Loop bundle builder page (/a/loop_subscriptions/bundle):
  // Loop reflects cart changes on every OTHER page by doing window.location.reload()
  // when it detects a mutation, but it DELIBERATELY skips that on this page
  // (loop_bundle.js -> setupMutationLoop early-returns for this path) and fires no
  // cart event. So the drawer / count / gamification never update on an in-page cart
  // change here until you navigate. We watch for cart changes (same idea Loop uses
  // elsewhere) and run our lightweight re-sync instead of a full page reload.
  // ---------------------------------------------------------------------------
  if (location.pathname.includes("/a/loop_subscriptions/bundle")) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    let lastCartKey = null;
    let bundleDebounce;

    async function checkBundleCart() {
      try {
        const c = await (await fetch(root + "cart.js", { cache: "no-store" })).json();
        const key = c.item_count + ":" + c.total_price;
        if (lastCartKey !== null && key !== lastCartKey) {
          // console.log("[cart-reload] bundle-page cart change detected", { from: lastCartKey, to: key });
          reloadCartDrawer("bundle-page-change");
        }
        lastCartKey = key;
      } catch (e) {
        // console.log("[cart-reload] bundle-page cart check failed", e);
      }
    }

    // Establish the baseline, then re-check shortly after any DOM mutation settles.
    // The item_count/total_price comparison means unrelated mutations are harmless
    // (at most an extra cart.js read) - we only re-sync when the cart actually changed.
    checkBundleCart();
    const bundleObserver = new MutationObserver(function () {
      clearTimeout(bundleDebounce);
      bundleDebounce = setTimeout(checkBundleCart, 500);
    });
    bundleObserver.observe(document.body, { childList: true, subtree: true });
  }
})();